export const INITIAL_STATE={values:{username:'',isUsernamePrivate:false},touched:{username:false,isUsernamePrivate:false},isSubmitting:false,error:''};